import * as React from 'react'

import { Grid } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import ContributionGroup from './ContributionGroup'
import EducationLevel from './EducationLevel'
import ProfessionalCategory from './ProfessionalCategory'
import RemoteContract from './RemoteContract'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const Spain = ({ contractVersion, employee }: Props) => {
  const { spanishContractData } = useLegalEntityContractData()
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  const professionalCategoryId = contractVersion.attributes.es_professional_category_id
  const cotizationGroupId = contractVersion.attributes.es_cotization_group
  const educationLevelId = contractVersion.attributes.es_education_level_id
  const hasRemoteContract = !!contractVersion.attributes.es_has_teleworking_contract

  const showProfessionalCategory = !!professionalCategoryId || canEdit
  const showCotizationGroup = !!cotizationGroupId || canEdit
  const showEducationLevel = !!educationLevelId || canEdit

  return (
    <Grid variant="fixed">
      {showProfessionalCategory && (
        <ProfessionalCategory
          categories={spanishContractData.professionalCategories}
          professionalCategoryId={professionalCategoryId ?? undefined}
        />
      )}
      {showCotizationGroup && (
        <ContributionGroup
          groups={spanishContractData.cotizationGroup}
          cotizationGroupId={cotizationGroupId ?? undefined}
        />
      )}
      {showEducationLevel && (
        <EducationLevel
          levels={spanishContractData.educationLevels}
          levelId={educationLevelId ?? undefined}
        />
      )}
      <RemoteContract hasRemoteContract={hasRemoteContract} />
    </Grid>
  )
}

export default observer(Spain)
